var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{ref:_vm.refProp,staticClass:"v-select",class:_vm.classes,attrs:{"data-cy":_vm.dataCy,"v-model":_vm.model,"autocomplete":_vm.autocomplete,"clearable":_vm.clearable,"value":_vm.model,"options":_vm.options},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }